import { alwaysFullWidthCardTypes } from "../card-routing/card-config";
import { INFO_CARD_TYPE } from "../card-routing/card-types";

/** Cards are always full width on mobile, regardless of type. */
export const mobileCardMaxWidth = "100%";

/** Desktop max width for card types that don't declare one of their own. */
export const defaultDesktopCardMaxWidth = 390;

export const searchDesktopCardMaxWidth = 500;
export const weatherDesktopCardMaxWidth = 800;
export const zoneDesktopCardMaxWidth = 500;

/**
 * Desktop max width per card type — the companion to `cardTypeFullWidthBreakpoints` in card-config.
 * Types absent here take the default width; `alwaysFullWidthCardTypes` ignore the table entirely.
 */
export const cardTypeDesktopMaxWidthPx: Partial<Record<INFO_CARD_TYPE, number>> = {
    [INFO_CARD_TYPE.SEARCH]: searchDesktopCardMaxWidth,
    [INFO_CARD_TYPE.WEATHER]: weatherDesktopCardMaxWidth,
    [INFO_CARD_TYPE.ZONE]: zoneDesktopCardMaxWidth,
};

export const getDesktopCardMaxWidthPx = (cardType: INFO_CARD_TYPE | undefined): number =>
    (cardType && cardTypeDesktopMaxWidthPx[cardType]) ?? defaultDesktopCardMaxWidth;

/** CSS width for a card's root element. */
export const resolveCardCssWidth = (cardType: INFO_CARD_TYPE | undefined, isMobileLayout: boolean): number | string =>
    // Always-full-width types ignore the breakpoint entirely, matching `calculateCardWidth` in
    // card-geometry.ts — the two must agree, or a card's width and its map panning offsets disagree.
    isMobileLayout || (cardType !== undefined && alwaysFullWidthCardTypes.has(cardType))
        ? mobileCardMaxWidth
        : getDesktopCardMaxWidthPx(cardType);
